/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action } from '@ember/object';
import { gt } from '@ember/object/computed';
import Component from '@ember/component';

@tagName('')
export default class Search extends Component {
  @gt('_email.length', 2) _canSearch;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);

    if (this.email !== this._email) {
      this.set('_email', this.email);
    }
  }

  @action
  search(evt) {
    evt.preventDefault();

    if (!this._canSearch) {
      return;
    }

    return this.onSearch(this._email);
  }

  @action
  clearSearch() {
    this.set('_email', '');
    return this.onSearch(this._email);
  }

  @action
  handleInput(value) {
    this.set('_email', value);
  }
}
